import { httpSetHelper } from '@klv/shared/utils/functions';

import type { SyntheticEvent } from 'react';
import type { FormikProps } from 'formik';
import type { TAccountAccessFormValues } from '../types';

export const handleWebsiteBlur = (event: SyntheticEvent, formik: FormikProps<TAccountAccessFormValues>) =>{
  const target = event.target as HTMLInputElement;
  if (target.name === 'websiteUrl') {
    httpSetHelper(formik, target);
  }
};
